import { render, staticRenderFns } from "./AdminProjectSync.vue?vue&type=template&id=5a21ad19&scoped=true"
import script from "./AdminProjectSync.vue?vue&type=script&lang=js"
export * from "./AdminProjectSync.vue?vue&type=script&lang=js"
import style0 from "./AdminProjectSync.vue?vue&type=style&index=0&id=5a21ad19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a21ad19",
  null
  
)

export default component.exports